import React, { Component } from "react";
import { connect } from "react-redux";
import HTMLReactParser from "html-react-parser";
import millify from "millify";

// Action
import { ClearLogs, getCurrencyDetail, getCoinHistory } from "../Actions";

import {
  Chart as ChartJS,
  RadialLinearScale,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  registerables,
} from "chart.js";

import { Line } from "react-chartjs-2";

//Assets
import MarketCap from "../Assets/MarketCapIcon.svg";
import Rank from "../Assets/rank.svg";
import Dollar from "../Assets/dollar.svg";
import Volume from "../Assets/Volume.svg";
import Info from "../Assets/info.svg";
import box4 from "../Assets/box4.svg";
import check from "../Assets/check.svg";
import cross from "../Assets/cross.svg";
import Loader from "../Assets/loader.gif";

ChartJS.register(
  RadialLinearScale,
  Legend,
  Tooltip,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  ...registerables
);

class CurrencyDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coinDetailData: null,
      coinPrice: [],
      coinTimestamp: [],
      loader: true,
    };
  }

  componentDidMount() {
    this.props.getCurrencyDetail(this.props?.location?.state?.coinId);
    this.props.getCoinHistory(this.props?.location?.state?.coinId, "24h");
  }

  componentDidUpdate(prevProps, nextState) {
    if (
      this.props.coinDetailStatus === "success" &&
      prevProps.coinDetailData !== this.props.coinDetailData
    ) {
      this.props.ClearLogs();
      this.setState({
        coinDetailData: this.props.coinDetailData?.data,
        loader: false,
      });
    }

    if (
      this.props.coinHistoryStatus === "success" &&
      prevProps.coinHistoryData !== this.props.coinHistoryData
    ) {
      this.props.ClearLogs();

      let coinPrice = [];
      let coinTimestamp = [];

      for (
        let i = 0;
        i < this.props.coinHistoryData?.data?.history?.length;
        i += 1
      ) {
        coinPrice.push(this.props.coinHistoryData?.data?.history[i].price);
      }

      for (
        let i = 0;
        i < this.props.coinHistoryData?.data?.history?.length;
        i += 1
      ) {
        coinTimestamp.push(
          new Date(
            this.props.coinHistoryData?.data?.history[i].timestamp
          ).toLocaleDateString()
        );
      }

      this.setState({
        coinPrice: coinPrice,
        coinTimestamp: coinTimestamp,
      });
    }
  }

  handelDrop = (e) => {
    this.props.getCoinHistory(
      this.props?.location?.state?.coinId,
      e.target.value
    );
  };

  render() {
    const data1 = {
      labels: this.state.coinTimestamp,
      datasets: [
        {
          label: "Price In USD",
          data: this.state.coinPrice,
          fill: true,
          borderColor: "#ffffff",
          pointBorderWidth: 10,
        },
      ],
    };

    if (this.state.loader) {
      return (
        <>
          <img src={Loader} alt="" className="Loader" />
        </>
      );
    }

    return (
      <div className="CurrencyDetails">
        <div className="CurrencyDetails_row1">
          <div className="CurrencyDetails_Title">
            {this.state.coinDetailData?.coin?.name} PRICE
          </div>
          <div className="CurrencyDetails_info">
            {this.state.coinDetailData?.coin?.name} live price in US Dollar
            (USD). View value statistics, market cap and supply.
          </div>
        </div>

        <div className="CurrencyDetails_graph">
          <div className="CurrencyDetails_graph_holder">
            <div className="CurrencyDetails_graph_data">
              <div>
                <select onChange={this.handelDrop}>
                  <option value="3h">3 Hours</option>
                  <option value="24h" selected>
                    24 Hours
                  </option>
                  <option value="7d">7 Days</option>
                  <option value="30d">30 Days</option>
                  <option value="3m">3 Months</option>
                  <option value="1y">1 Year</option>
                  <option value="3y">3 Year</option>
                  <option value="5y">5 Year</option>
                </select>
              </div>
              <div>
                CURRENT {this.state.coinDetailData?.coin?.name} PRICE:{" "}
                {`$ ${millify(this.state.coinDetailData?.coin?.price)}`}{" "}
              </div>
            </div>
            <Line
              data={data1}
              height={100}
              options={{
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                  },
                  y: {
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: true,
                    position: "top",
                  },
                },
              }}
            />
          </div>
        </div>

        <div className="CurrencyDetails_row3">
          <div className="CurrencyDetails_card">
            <div className="CurrencyDetails_card_holder">
              <div className="CurrencyDetails_cardTitle">
                {this.state.coinDetailData?.coin?.name} VALUE STATUS
              </div>
              <div className="CurrencyDetails_cardInfo">
                An overview which shows status of{" "}
                {this.state.coinDetailData?.coin?.name}
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Dollar} alt="" />
                  <div>Price to USD</div>
                </div>
                <div>{`$ ${
                  this.state.coinDetailData?.coin?.price &&
                  millify(this.state.coinDetailData?.coin?.price)
                }`}</div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Rank} alt="" />
                  <div>Rank</div>
                </div>
                <div>{`${this.state.coinDetailData?.coin?.rank}`}</div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Volume} alt="" />
                  <div>24h Volume</div>
                </div>
                <div>{`$ ${
                  this.state.coinDetailData?.coin["24hVolume"] &&
                  millify(this.state.coinDetailData?.coin["24hVolume"])
                }`}</div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={MarketCap} alt="" />
                  <div>Market Cap</div>
                </div>
                <div>{`$ ${
                  this.state.coinDetailData?.coin?.marketCap &&
                  millify(this.state.coinDetailData?.coin?.marketCap)
                }`}</div>
              </div>
            </div>
          </div>

          <div className="CurrencyDetails_card">
            <div className="CurrencyDetails_card_holder">
              <div className="CurrencyDetails_cardTitle">
                OTHER STATICS INFO
              </div>
              <div className="CurrencyDetails_cardInfo">
                An overview which shows status of{" "}
                {this.state.coinDetailData?.coin?.name}
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Dollar} alt="" />
                  <div>Number Of Markets</div>
                </div>
                <div>{this.state.coinDetailData?.coin?.numberOfMarkets}</div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Rank} alt="" />
                  <div>Number Of Exchanges</div>
                </div>
                <div>{this.state.coinDetailData?.coin?.numberOfExchanges}</div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Info} alt="" />
                  <div>Approved Supply</div>
                </div>
                <div>
                  <img
                    src={
                      this.state.coinDetailData?.coin?.supply?.confirmed
                        ? check
                        : cross
                    }
                    alt=""
                    style={{ width: "35px", margin: "0" }}
                  />
                </div>
              </div>

              <div className="CurrencyDetails_cardItem">
                <div>
                  <img src={Info} alt="" />
                  <div>Total Supply</div>
                </div>
                <div>{`$ ${
                  this.state.coinDetailData?.coin?.supply?.total &&
                  millify(this.state.coinDetailData?.coin?.supply?.total)
                }`}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="CurrencyDetails_row4">
          <div className="CurrencyDetails_coinData">
            <h3>WHAT IS {this.state.coinDetailData?.coin?.name} ?</h3>
            {HTMLReactParser(`${this.state.coinDetailData?.coin?.description}`)}
          </div>
          <div
            className="CurrencyDetails_card CurrencyDetails_cardFloat"
            style={{ height: "fit-content" }}
          >
            <div className="CurrencyDetails_card_holder">
              <div className="CurrencyDetails_cardTitle">
                {this.state.coinDetailData?.coin?.name} LINK
              </div>
              {this.state.coinDetailData?.coin?.links.map((link, index) => {
                return (
                  <div className="CurrencyDetails_cardItem" key={index}>
                    <div>
                      <div>{link.type}</div>
                    </div>
                    <div>
                      <a href={link.url} target="_blank" rel="noreferrer">
                        {link.name}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="CurrencyDetails_bg">
          <img src={box4} alt="" className="CurrencyDetails_box" />
          <div className="CurrencyDetails_cir"></div>
          <div className="CurrencyDetails_cir2"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    coinHistoryData: state.appData.coinHistoryData,
    coinHistoryStatus: state.appData.coinHistoryStatus,

    coinDetailData: state.appData.coinDetailData,
    coinDetailStatus: state.appData.coinDetailStatus,
  };
};

export default connect(mapStateToProps, {
  ClearLogs,
  getCurrencyDetail,
  getCoinHistory,
})(CurrencyDetails);
